module.exports = __webpack_public_path__ + "static/media/fake_logo_bleu.56c6a70d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fake_logo_bleu.jpg
// module id = 1760
// module chunks = 0